<ng-container [formGroup]="parent">
  <ng-container formGroupName="lines">
    <h3 class="mb-2">Line detail</h3>
    <div class="row">
      <div class="col-3 mb-2" [hidden]="orderType === 'inventory-sales'">
        <div class="form-group has-float-label">
          <label class="form-label">Vendor SKU</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            formControlName="externalItemNumberD365"
            (focusout)="applyVendorSkuLengthValidation($event)" />
        </div>
      </div>
      <div class="col-3 mb-2">
        <!-- <div
            class="form-group has-float-label"
            [hidden]="orderType !== 'inventory-sales'"
          >
            <ng-select
              
              id="currency"
              formControlName="itemNumberD365"
              [ngClass]="{ 'has-error': formErrors.itemNumberD365 }"
              (blur)="logValidationErrors()"
              (change)="itemSelected($event)"
            >
              <ng-option *ngFor="let com of filteredReleasedProductsList" [value]="com">
                {{ com }}
              </ng-option>
            </ng-select>
            <label class="form-label">{{ labelType }}<span class="madatory-field">*</span></label>
            <span class="error-msg" *ngIf="formErrors.itemNumberD365">
              {{ formErrors.itemNumberD365 }}
            </span>
          </div> -->
        <div class="form-group has-float-label">
          <label class="form-label"
            >{{ labelType }}<span class="madatory-field">*</span></label
          >
          <p-select
            id="currency"
            formControlName="itemNumberD365"
            [ngClass]="{ 'has-error': formErrors['itemNumberD365'] }"
            (blur)="logValidationErrors()"
            (onChange)="itemSelected($event)"
            [options]="filteredReleasedProductsList"
            optionLabel="itemNumberD365"
            optionValue="itemNumberD365"
            [filter]="true"
            [showClear]="true">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['itemNumberD365']">
            {{ formErrors["itemNumberD365"] }}
          </span>
        </div>
      </div>
      <div class="col-3 mb-2" [hidden]="orderType === 'inventory-purchase'">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Sales Classification<span *ngIf="isSalesClassificationIdRequired"
              >*</span
            ></label
          >
          <p-select
            id="currency"
            formControlName="salesClassificationD365"
            [ngClass]="{ 'has-error': formErrors['salesClassificationD365'] }"
            (blur)="logValidationErrors()"
            [options]="salesClasssificationList"
            [filter]="true"
            [showClear]="true"
            optionLabel="name"
            optionValue="value">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['salesClassificationD365']">
            {{ formErrors["salesClassificationD365"] }}
          </span>
        </div>
      </div>

      <div class="col-3 mb-2" [hidden]="orderType === 'inventory-purchase'">
        <div class="form-group has-float-label">
          <label class="form-label">Tracking Nickname</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            formControlName="nickName"
            (focusout)="applyNickNameLengthValidation($event)" />
        </div>
      </div>

      <div
        class="col-3 mb-2"
        [hidden]="
          orderType === 'all-sales' || orderType === 'inventory-purchase'
        ">
        <div class="form-group has-float-label flex-grow-1">
          <label class="form-label">{{
            orderType === "inventory-sales" ? "Product Name" : "Category Name"
          }}</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            formControlName="categoryName" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3 mb-2">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Quantity <span class="madatory-field">*</span></label
          >
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            formControlName="orderedPurchaseQuantityD365"
            (focusout)="onQuantityChange($event)"
            [ngClass]="{
              'has-error': formErrors['orderedPurchaseQuantityD365'],
            }"
            (blur)="logValidationErrors()" />

          <span
            class="error-msg"
            *ngIf="formErrors['orderedPurchaseQuantityD365']">
            {{ formErrors["orderedPurchaseQuantityD365"] }}
          </span>
        </div>
      </div>

      <div class="col-3 mb-2 d-flex align-items-center">
        <!-- Hide as per the ticket 11475 -->
        <input
          pInputText
          *ngIf="false"
          type="checkbox"
          class="form-check-input me-2 no-bg"
          formControlName="isnetInForeignCurrencyStatus"
          [disabled]="this.userBlockedFromEdit || this.isFromCdi"
          (click)="onCurrencyEnable($event)" />

        <div class="form-group has-float-label flex-grow-1">
          <label class="form-label">Net Currency</label>
          <p-select
            #currencySelect
            class="cleardropdownicon"
            id="currency"
            formControlName="currencyCodeD365"
            (change)="onCurrencyConversion()"
            [disabled]="true"
            [options]="currencyList"
            optionLabel="isoCurrencyCodeD365"
            optionValue="isoCurrencyCodeD365"
            [filter]="true"
            [showClear]="true">
          </p-select>
        </div>
      </div>
      <div class="col-3" [hidden]="orderType === 'inventory-purchase'">
        <div class="form-group switcher mt-3">
          <label class="form-label d-block l-height mb-0">Trackable</label>
          <div class="form-check form-switch d-flex align-items-center m-0">
            <p-toggleswitch
              type="checkbox"
              id="trackable"
              name="trackable"
              formControlName="isTrackable" />

            <label class="form-check-label" for="trackable">
              {{ this.parent.get(["lines", "isTrackable"])?.value }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-3" *ngIf="orderType === 'inventory-purchase'">
        <div class="form-group switcher mt-3">
          <label class="form-label d-block l-height mb-0">Final</label>
          <div
            class="form-check form-switch d-flex align-items-center m-0 gap-2">
            <p-toggleswitch
              type="checkbox"
              id="trackable"
              name="trackable"
              formControlName="final" />

            <label class="form-check-label" for="trackable">
              {{ this.parent.get(["lines", "final"])?.value }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-3" *ngIf="orderType === 'inventory-purchase'">
        <div class="form-group switcher mt-3">
          <label class="form-label d-block l-height mb-0">Excluded</label>

          <div
            class="form-check form-switch d-flex align-items-center m-0 gap-2">
            <p-toggleswitch
              type="checkbox"
              id="trackable"
              name="trackable"
              formControlName="excluded" />
            <label class="form-check-label" for="trackable">
              {{ this.parent.get(["lines", "excluded"])?.value }}
            </label>
          </div>
        </div>
      </div>
      <div
        class="col-3 mb-2"
        [hidden]="
          orderType === 'all-sales' || orderType === 'inventory-purchase'
        ">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Color<span class="madatory-field">*</span></label
          >
          <p-select
            id="currency"
            formControlName="color"
            [ngClass]="{ 'has-error': formErrors['color'] }"
            (change)="colorSelected()"
            (blur)="logValidationErrors()"
            [showClear]="true"
            [filter]="true"
            [options]="filteredColors">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['color']">
            {{ formErrors["color"] }}
          </span>
        </div>
      </div>
      <div
        class="col-3 mb-2"
        [hidden]="
          orderType === 'all-sales' || orderType === 'inventory-purchase'
        ">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Size<span class="madatory-field">*</span></label
          >
          <p-select
            id="currency"
            formControlName="size"
            [ngClass]="{ 'has-error': formErrors['size'] }"
            (onChange)="sizeSelected()"
            (blur)="logValidationErrors()"
            [options]="filteredSizes"
            [filter]="true"
            [showClear]="true">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['size']">
            {{ formErrors["size"] }}
          </span>
        </div>
      </div>
      <div
        class="col-3 mb-2"
        [hidden]="
          orderType === 'all-sales' || orderType === 'inventory-purchase'
        ">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Style<span class="madatory-field">*</span></label
          >
          <p-select
            id="currency"
            formControlName="style"
            [ngClass]="{ 'has-error': formErrors['style'] }"
            (change)="styleSelected()"
            (blur)="logValidationErrors()"
            [options]="filteredStyles"
            [showClear]="true"
            [filter]="true">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['style']">
            {{ formErrors["style"] }}
          </span>
        </div>
      </div>
      <div
        class="col-3 mb-2"
        [hidden]="
          orderType === 'all-sales' || orderType === 'inventory-purchase'
        ">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Config<span class="madatory-field">*</span></label
          >
          <p-select
            id="currency"
            formControlName="config"
            [ngClass]="{ 'has-error': formErrors['config'] }"
            (change)="configSelected()"
            (blur)="logValidationErrors()"
            [options]="filteredConfigs"
            [filter]="true"
            [showClear]="true">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['config']">
            {{ formErrors["config"] }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3" [hidden]="orderType === 'inventory-purchase'">
        <div class="row">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">Sell</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellRateValueWithIcon
                    | currency: sellIsoCurrencyCode : 'symbol' : '0.3-3'
                "
                (focusout)="onSellConversion($event)"
                [disabled]="sellRateValueWithIconStatus" />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="sellCurrencyStatus">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellConvertToUsd | currency: 'USD' : 'symbol' : '0.3-3'
                "
                disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col mb-3">
        <div class="row">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">NET</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  netValueWithIcon
                    | currency: isoCurrencyCode : 'symbol' : '0.4-4'
                "
                (focusout)="onNetConversion($event)" />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="showForeignCurrency">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="netConvertToUsd | currency: 'USD' : 'symbol' : '0.4-4'"
                disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mb-3" [hidden]="orderType === 'inventory-purchase'">
        <div class="row">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">Sell Total</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellTotalPrice
                    | currency: sellIsoCurrencyCode : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="sellCurrencyStatus">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  sellTotalPriceConverted | currency: 'USD' : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col mb-3">
        <div class="row">
          <div class="col has-icon">
            <div class="form-group has-float-label">
              <label class="form-label">Net Total</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  netTotalPrice | currency: isoCurrencyCode : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label" *ngIf="showForeignCurrency">
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="
                  netTotalPriceConverted | currency: 'USD' : 'symbol' : '1.2-2'
                "
                disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" [hidden]="orderType === 'inventory-purchase'">
      <div class="col">
        <div class="form-group has-float-label" *ngIf="showCommissionsFields">
          <label class="form-label">Commission</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            [value]="commission | currency: 'USD'"
            disabled />
        </div>
      </div>
      <div class="col">
        <div class="form-group has-float-label">
          <label class="form-label">Gross Profit %</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            [value]="grossProfit"
            disabled />
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
